import '../Inscription.less';
import { Button, Layout,Menu , Row, Col,Modal,Select,ConfigProvider,Table} from 'antd';
import { BarChartOutlined} from '@ant-design/icons';
import React, { Component } from "react";
import 'react-phone-input-2/lib/style.css'
import moment from 'moment';
import es_ES from 'antd/lib/locale/es_ES';
import {NavLink} from "react-router-dom";
import generatePDFConc from './services/reportGenerator' 
import generatePDFPlay from './services/reportGeneratorPlays' 
import generatePDFPlaysByCountry from './services/reports'
import {getAuthors,getAuthorsStr, getCountryName,IP} from '../components/utils';
import Foot from "../components/Footer"
import AdminMenu from "../components/AdminMenu"
 

class AdminHome extends Component {
  constructor(props){
    super(props)
    this.state={
      plays: {},
      todayPlays: 0,
      todayConc: 0,
      totalConc: 0,
      totalPlays: 0 ,
      genres: {},
      conc_report:[],
      plays_report:[],
      makeGenreReport:false,
      reportByAuthor:true,
      reportGenre:'Novela',
      reportCountry:null,
      makeCountryReport:false,
      isBusy:true
    }
  }
  async componentDidMount() {
    const plays = await fetch(IP +'api/casa/obra/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    const json_plays = await plays.json();
    if(json_plays['detail']){//if no authorization,returns dict with detail key
      localStorage.clear()
      window.location.reload(); 
    }
    var si = json_plays.filter(p=>p.califica && p.genero == 5)
    var no = json_plays.filter(p=>!p.califica && p.genero == 5)
    console.log("NO",no.map(p=>{
      var arr =   p.pdf.split("/")
      return arr[arr.length - 1]
  }))
    console.log("SI",si.map(p=>{
      var arr =   p.pdf.split("/")
      return arr[arr.length - 1]
  }))
    console.log("TODAS",json_plays.filter(p=>p.genero == 5))
    const genres = await fetch(IP + 'api/casa/genero/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
   
    
   
    const json_conc = [].concat.apply([],json_plays.map(play=> {return play.conc}))
    const json_genres = await genres.json();
    const genres_dict = {}
    json_genres.forEach(element => {
      genres_dict[element.id] = element.nombre
    });
    var data_play = []
  
    const Moment = require('moment');

    for(var i in json_plays){//build plays data to display
      var item = json_plays[i];
      var date= new Moment(item.fecha_registro).format('DD-MM-YYYY')
      var author= getAuthors(item.conc)
      var authorStr = getAuthorsStr(item.conc).join(", ")
      const year = date.split('-')[2]
      data_play.push(
          { 
              id : i,
              title : item.titulo,
              author: author ,
              authorStr:authorStr,
              date:date,
              pseudo: item.pseudonimo,
              code:year+'_'+item.genero+'_'+item.id,
              conc:item.conc,
              category:genres_dict[item.genero],
              pdf:item.pdf,
              edit:''
          });
    };
    var data_conc = []
    for(var i in json_conc){//build concs data to display
      var item = json_conc[i];
    
      data_conc.push(
          { 
              id : item.id,
              name : item.nombre_completo,
              country: getCountryName(item.pais),
              ficha: item.ficha,
              phone: item.telefono,
              address: item.direcc_personal,
              email: item.email,
          });
    };
    var genresByCountry={ }
    var todayNovela = 0
    var todayEstudios = 0
    var todayTestimonial = 0
    var todayBr = 0
    var totNovela = 0
    var totEstudios = 0
    var totTestimonial = 0
    var totBr = 0
    var todayPlays = 0
    var todayConc = 0
    var totalConc = 0

    for(var key in json_plays){//build data for Plays by country Table and By Genre
      var play = json_plays[key]
      
      var country = play['conc'][0]['pais']
      var countryName = getCountryName(country)
      if(!(countryName in genresByCountry)){
        genresByCountry[countryName] ={}
        genresByCountry[countryName]["total"] =0

        for(var g in json_genres){
          var gen = json_genres[g]["nombre"]
          genresByCountry[countryName][gen] = {"today":0,"total":0}
          console.log("gen:",gen)
         }
      }
      var playDate = moment(play.fecha_registro).format('DD-MM-YYYY')
      var today = moment().format('DD-MM-YYYY')
     

      if(today == playDate){
        genresByCountry[countryName][genres_dict[play.genero]]["today"] += 1
        if(genres_dict[play.genero] === "Novela"){
          todayNovela += 1
        }
        if(genres_dict[play.genero] === "Ensayo de tema artístico-literario"){
          todayBr += 1
        }
        if(genres_dict[play.genero] === "Teatro"){
          todayEstudios += 1
        }
        if(genres_dict[play.genero] === "Literatura para niños y jóvenes"){
          todayTestimonial += 1
        }
        for(var aut in play.conc){
          todayConc +=1
        }
        todayPlays += 1
       
      }
      genresByCountry[countryName][ genres_dict[play.genero] ]["total"] += 1
      genresByCountry[countryName]["total"] += 1
      if(genres_dict[play.genero] === "Novela"){
        totNovela += 1
      }
      if(genres_dict[play.genero] === "Teatro"){
        totEstudios += 1
      }
      if(genres_dict[play.genero] === "Ensayo de tema artístico-literario"){
        totBr += 1
      }
      if(genres_dict[play.genero] === "Literatura para niños y jóvenes"){
        totTestimonial += 1
      }
      totalConc+= Object.keys(play.conc).length
    }
    this.setState({ plays: genresByCountry,todayPlays:todayPlays,todayConc:todayConc, totalConc:totalConc,todayBr:todayBr,totBr:totBr, todayTestimonial:todayTestimonial,todayNovela:todayNovela,todayEstudios:todayEstudios, totTestimonial:totTestimonial, totNovela:totNovela, totEstudios:totEstudios, genres:json_genres,totalPlays:Object.keys(json_plays).length,isBusy:false,conc_report: data_conc, plays_report: data_play });
  }
 
  render() {
    const { Content } = Layout;
    const { Option } = Select;
    const { SubMenu } = Menu;
    const { Column, ColumnGroup } = Table;
    
    const dataC = [//Concs Table
      {
        key: '1',
        todayConc: this.state.todayConc,
        totalConc: this.state.totalConc,
        
      },
    ];
    var data =  Object.keys(this.state.plays).map((k,index)=>// By country
      {
        var row = {
          key:index,
          country:k,
        }
        for(var g in this.state.plays[k]){
          row["today"+g]= this.state.plays[k][g]["today"]
          row["total"+g]= this.state.plays[k][g]["total"]
          row["total"] = this.state.plays[k]["total"]
        }
        return row
      })

    data = data.sort((a, b) => a.country.localeCompare(b.country))//Sort By country Name
    const dataP = [//By genre
      {
        key: '1',
        genre:"Novela",
        todayPlays: <div style={{fontSize:'large' }}>{this.state.todayNovela}</div>,
        totalPlays:<div style={{fontSize:'large' }}>{this.state.totNovela}</div> ,
        
      },
      {
        key: '2',
        genre:"Teatro",
        todayPlays:this.state.todayEstudios ,
        totalPlays: this.state.totEstudios,
        
      },
      {
        key: 3,
        genre:"Literatura para niños y jóvenes",
        todayPlays: this.state.todayTestimonial,
        totalPlays: this.state.totTestimonial,
        
      },
      {
        key: 5,
        genre:"Ensayo de tema artístico-literario",
        todayPlays: this.state.todayBr,
        totalPlays: this.state.totBr,
        
      },
      {
        key: 4,
        todayPlays: this.state.todayPlays,
        totalPlays: this.state.totalPlays,
        genre:<div style={{fontSize:'large', fontWeight:'bold' }}>Total</div>
        
      },
    ];

    //Conc's Reports
    const downloadConcReport =()=> generatePDFConc(this.state.conc_report,"save")
    const readConcReport =()=> generatePDFConc(this.state.conc_report,"read")
    // 

    //Play's Reports
      //General by author
    const downloadPlayReport =()=> generatePDFPlay(this.state.plays_report,"save")
    const readPlayReport =()=> generatePDFPlay(this.state.plays_report,"read")
      //General by pseudo
    const downloadPlayReportPseudo =()=> generatePDFPlay(this.state.plays_report,"save",false,false,'',false)
    const readPlayReportPseudo =()=> generatePDFPlay(this.state.plays_report,"read",false,false,'',false)

    const downloadPlayCountryReport =()=> generatePDFPlaysByCountry(data,"save")
    const readPlayCountryReport =()=> generatePDFPlaysByCountry(data,"read")

    const downloadPlayReportSelectedCountry=()=> generatePDFPlay(this.state.plays_report.filter(p=>Object.entries(p.conc)[0][1]['pais'] == this.getCountryCode(this.state.reportCountry)),"save",false,true,this.state.reportCountry,true)
    const readPlayReportSelectedCountry =()=> generatePDFPlay(this.state.plays_report.filter(p=>Object.entries(p.conc)[0][1]['pais'] == this.getCountryCode(this.state.reportCountry)),"read",false,true,this.state.reportCountry,true)

    const downloadPlayReportGenre =()=> generatePDFPlay(this.state.plays_report.filter(p=>p.category == this.state.reportGenre),"save",false,false,'',false)
    const readPlayReportGenre =()=> generatePDFPlay(this.state.plays_report.filter(p=>p.category == this.state.reportGenre),"read")

    const downloadPlayReportGenrePseudo =()=> generatePDFPlay(this.state.plays_report.filter(p=>p.category == this.state.reportGenre),"save",false,false,'',false)
    const readPlayReportGenrePseudo =()=> generatePDFPlay(this.state.plays_report.filter(p=>p.category == this.state.reportGenre),"read",false,false,'',false)


    const downloadPlayReportSelectedCountryPseudo=()=> generatePDFPlay(this.state.plays_report.filter(p=>Object.entries(p.conc)[0][1]['pais'] == this.getCountryCode(this.state.reportCountry)),"save",false,true,this.state.reportCountry,false)
    const readPlayReportSelectedCountryPseudo =()=> generatePDFPlay(this.state.plays_report.filter(p=>Object.entries(p.conc)[0][1]['pais'] == this.getCountryCode(this.state.reportCountry)),"read",false,true,this.state.reportCountry,false)
    const onClickGenreReport=()=>{
      this.setState({makeGenreReport:true})
    }
    const onClosekGenreReport=()=>{
      this.setState({makeGenreReport:false})
    }
    const onChangeReportGenre = (value) =>{this.setState({reportGenre:value})}

    const onClickCountryReport=()=>{
      this.setState({makeCountryReport:true})
    }
    const onClosekCountryReport=()=>{
      this.setState({makeCountryReport:false})
    }
    const onChangeReportCountry = (value) =>{this.setState({reportCountry:value})}


    const reportMenu = (
    <SubMenu disabled={this.state.isBusy} key="reports" icon={<BarChartOutlined style={{ fontSize: '26px'}} />} style={{fontSize:'20px', fontWeight:'bold', color:'black'}} title="Reportes">
      <SubMenu  key="play" title ={<h4 style={{ fontWeight:'bold', color:'black'}}>Reportes de obras</h4>}>
        <SubMenu  key="playAuth" title ={<h4 style={{ fontWeight:'bold', color:'black'}}>Con autores</h4>}>
          <Menu.ItemGroup title={<h4 style={{  color:'black'}}>General</h4>}>
            <Menu.Item>
                <Button onClick={readPlayReport}>Ver</Button> <Button onClick={downloadPlayReport}>Descargar</Button>
            </Menu.Item>
          </Menu.ItemGroup>
          <Menu.Item>
            <h4 onClick={()=>{this.setState({reportByAuthor:true},()=>onClickCountryReport())}}  style={{  color:'black'}}>Por país específico</h4>
          </Menu.Item>
          <Menu.Item style={{ fontWeight:'bold'}} >
            <h4 onClick={()=>{this.setState({reportByAuthor:true},()=>onClickGenreReport())}}  style={{  color:'black'}}>Por Genero</h4>
          </Menu.Item>
        </SubMenu>
        <SubMenu  key="playPseudo" title ={<h4 style={{ fontWeight:'bold', color:'black'}}>Con seudónimo</h4>}>
          <Menu.ItemGroup title={<h4 style={{  color:'black'}}>General</h4>}>
              <Menu.Item>
                  <Button onClick={readPlayReportPseudo}>Ver</Button> <Button onClick={downloadPlayReportPseudo}>Descargar</Button>
              </Menu.Item>
            </Menu.ItemGroup>
            <Menu.Item>
              <h4 onClick={()=>{this.setState({reportByAuthor:false},()=>onClickCountryReport())}}  style={{  color:'black'}}>Por país específico</h4>
            </Menu.Item>
            <Menu.Item style={{ fontWeight:'bold'}} >
              <h4 onClick={()=>{this.setState({reportByAuthor:false},()=>onClickGenreReport())}}  style={{  color:'black'}}>Por Genero</h4>
            </Menu.Item>
        </SubMenu>
        <Menu.ItemGroup style={{ fontWeight:'bold'}} title={<h4 style={{  color:'black'}}>Por países</h4>}>
          <Menu.Item>
            <Button onClick={readPlayCountryReport}>Ver</Button> <Button onClick={downloadPlayCountryReport}>Descargar</Button>
          </Menu.Item>
        </Menu.ItemGroup>
      </SubMenu>
      <SubMenu  key="r" title = {<h4 style={{ fontWeight:'bold', color:'black'}}>Reportes de concursantes</h4>}>
        <Menu.ItemGroup style={{ fontWeight:'bold'}} title={<h4 style={{  color:'black'}}>General</h4>}>
          <Menu.Item>
            <Button onClick={readConcReport}>Ver</Button> <Button onClick={downloadConcReport}>Descargar</Button>
          </Menu.Item>
        </Menu.ItemGroup>
      </SubMenu>
    </SubMenu>)
    return (
          <div className="page-container">
            <div className = "content-wrap">
              <ConfigProvider locale={es_ES}>
                <Layout style={{backgroundColor:'white'}}>
                  <AdminMenu defaultSelectedKey={"home"} reportMenu={reportMenu} />
                  <Content>
                  <Row  justify="center" align="middle" >
                  <Col span={8}>
                    <br></br>
                    <Table loading={this.state.isBusy} bordered dataSource={dataP} pagination={false} size='small' style={{fontSize:'large'}} >
                        <ColumnGroup title={ <div style={{fontWeight:'bold', fontSize:'x-large' }}> <NavLink to="/casa/admin_plays_list">Obras</NavLink> </div>}>
                        <Column title={(<div style={{ fontWeight:'bold', fontSize:'large'}}>
                          Género</div>)} dataIndex="genre" key="genre" align='center'
                          render = {(text,record)=> {
                            return {
                              props: {
                                style: { background: record.key == 4 ? '#e6e6e6' : "white",fontSize:'large' }
                              },
                              children: <div>{text}</div>
                            }} }/>
                          <Column title={(<div style={{ fontWeight:'bold', fontSize:'large'}}>Hoy</div>)} dataIndex="todayPlays" key="todayPlays" align='center' render = {(text,record)=> {
                            return {
                              props: {
                                style: { background: record.key == 4 ? '#e6e6e6' : "white",fontSize:'large' }
                              },
                              children: <div>{text}</div>
                            }} } />
                          <Column title={(<div style={{ fontWeight:'bold', fontSize:'large'}}>Total</div>)}dataIndex="totalPlays" key="totalPlays"  align='center'render = {(text,record)=> {
                            return {
                              props: {
                                style: { background: record.key == 4 ? '#e6e6e6' : "white",fontSize:'large' }
                              },
                              children: <div>{text}</div>
                            }} } />
                        </ColumnGroup>
                      </Table>
                      <br/>
                      <Row  justify="center" align="middle" >
                
                        <Col span={12} >
                          
                          <Table loading={this.state.isBusy}  bordered dataSource={dataC} pagination={false}size='small' >
                            <ColumnGroup title={ <div style={{fontWeight:'bold', fontSize:'x-large' }}> <NavLink to="/casa/admin_conc_list">Concursantes</NavLink></div>}>
                              <Column title={(<div style={{ fontWeight:'bold', fontSize:'large'}}>Hoy</div>)} dataIndex="todayConc" key="todayConc" align='center'
                              render = {(text,record)=> {
                                return {
                                  props: {
                                    style: { background: record.key == 4 ? '#e6e6e6' : "white",fontSize:'large' }
                                  },
                                  children: <div>{text}</div>
                                }} } />
                              <Column title={(<div style={{ fontWeight:'bold', fontSize:'large'}}>Total</div>)} dataIndex="totalConc" key="totalConc" align='center'
                              render = {(text,record)=> {
                                return {
                                  props: {
                                    style: { background: record.key == 4 ? '#e6e6e6' : "white",fontSize:'large' }
                                  },
                                  children: <div>{text}</div>
                                }} } />
                            </ColumnGroup>
                          </Table>
                        </Col>
                
                      </Row>
                    </Col>

                    <Col span={12}>
                      <br></br>
                      <Table loading={this.state.isBusy} bordered dataSource={data} pagination={false} size='small' style={{fontSize:'large', marginLeft:'10px'}} >
                        <ColumnGroup title={ <div style={{fontWeight:'bold', fontSize:'x-large' }}> <NavLink to="/casa/admin_plays_list">Obras</NavLink> </div>}>
                        <Column title={(<div style={{ fontWeight:'bold', fontSize:'x-large'}}>
                          País</div>)} dataIndex="country" key="genre" align='center'
                          render = {(text,record)=> {
                            return {
                              props: {
                                style: { background: "white",fontSize:'large' }
                              },
                              children: <div>{text}</div>
                            }} }
                          
                            />
                            
                          {Object.keys(this.state.genres).filter(g=>this.state.genres[g]["nombre"] !='Admin').map(key=>{ 
                            var c = 
                          (
                            <ColumnGroup title={ <div style={{fontWeight:'bold', fontSize:'x-large' }}> {this.state.genres[key]["nombre"]} </div>}>
                              <Column title={(<div style={{  fontSize:'large'}}>Hoy</div>)} dataIndex={"today"+this.state.genres[key]["nombre"] } key="todayPlays" align='center' render = {(text,record)=> {
                                return {
                                  props: {
                                    style: { background:"white",fontSize:'large' }
                                  },
                                  children: <div>{text}</div>
                                }} } />
                              <Column title={(<div style={{ fontSize:'large'}}>Total</div>)}dataIndex={"total"+this.state.genres[key]["nombre"] } key="totalPlays"  align='center'render = {(text,record)=> {
                                return {
                                  props: {
                                    style: { background:  "white",fontSize:'large' }
                                  },
                                  children: <div>{text}</div>
                                }} } />
                            </ColumnGroup>
                          
                        )
                        
                        return c
                            
                          
                        })}
                        <Column title={(<div style={{ fontWeight:'bold', fontSize:'x-large'}}>
                          Total</div>)} dataIndex="total" key="total" align='center'
                          render = {(text,record)=> {
                            return {
                              props: {
                                style: { background: "white",fontSize:'large' }
                              },
                              children: <div>{text}</div>
                            }} }/>
                        </ColumnGroup>
                      </Table>
                      <br/>
                    </Col>
                  </Row>

                  {this.state.makeGenreReport &&
                  <Modal
                  closable = {false}
                  title="Reporte por género"
                  visible={this.state.makeGenreReport}
                  footer={[
                    <Button key="back" onClick={onClosekGenreReport}>
                    Regresar
                    </Button>,
                ]}
                  >
                      <Select
                      style={{width:'80%'}}
                      defaultValue={this.state.reportGenre}
                      onChange={onChangeReportGenre}
                      >
                        {Object.entries(this.state.genres).map(element => {if(element[1].nombre!='Admin')return <Option value={element[1].nombre}>{element[1].nombre}</Option>})}
                      </Select>
                      <div>
                        <br/>
                        <Button onClick={this.state.reportByAuthor ? readPlayReportGenre: readPlayReportGenrePseudo}>Ver</Button> <Button onClick={this.state.reportByAuthor ? downloadPlayReportGenre: downloadPlayReportGenrePseudo}>Descargar</Button>
                      </div>
                  </Modal>}

                  {this.state.makeCountryReport &&
                  <Modal
                  closable = {false}
                  title="Reporte por país"
                  visible={this.state.makeCountryReport}
                  footer={[
                    <Button key="back" onClick={onClosekCountryReport}>
                    Regresar
                    </Button>,
                ]}
                  >
                      <Select
                      style={{width:'80%'}}
                      defaultValue={this.state.reportCountry}
                      onChange={onChangeReportCountry}
                      >
                        {Object.entries(data).map(element => {return <Option value={element[1].country}>{element[1].country}</Option>})}
                      </Select>
                      <div>
                        <br/>
                        <Button onClick={this.state.reportByAuthor ? readPlayReportSelectedCountry: readPlayReportSelectedCountryPseudo}>Ver</Button> <Button onClick={this.state.reportByAuthor ? downloadPlayReportSelectedCountry: downloadPlayReportSelectedCountryPseudo}>Descargar</Button>
                      </div>
                  </Modal>}
              </Content>
              </Layout>
            </ConfigProvider>
        </div>
        <Foot admin={true}/>
        </div>

        );
  }
}
export default AdminHome;


